import { produce } from 'immer'
import createReducer from "./reducerUtils"

const initialState = {
    grades: null,
    testTakers: null,
    schoolClasses: null,
    learningGroups: null,
    testTaker: {},
}

const grades = {
    setGrades(state, action) {
        state.grades = action.payload
    },
    setSchoolClasses(state, action) {
        state.schoolClasses = action.payload
    },
    setLearningGroups(state, action) {
        state.learningGroups = action.payload
    },
    setTestTaker(state, action) {
        state.testTaker = action.payload
    },
    cleanTestTakers(state, action) {
        state.testTakers = null
    },
    cleanTestTaker(state, action) {
        state.testTaker = {}
    },
    editTestTaker(state, action) {
        state.testTaker = { ...state.testTaker, ...action.payload }
    },
    setTestTakers(state, action) {
        state.testTakers = action.payload
    },
}

export default produce(
    (state, action) => createReducer(state, action, grades),
    initialState
)

